let copy

export default {
    bind(el, binding) {
        copy = (event) => {
            if (window.getSelection) {
                window.getSelection().selectAllChildren(el);
            }
            else { // старый IE
                var range = document.selection.createRange();
                range.moveToElementText(el);
                range.select();
            }
            // document.execCommand('copy')
        }

        el.addEventListener('click', copy)
    },
    unbind(el, binding) {
        el.removeEventListener('click', copy)
    }
}


// WEBPACK FOOTER //
// ./src/webpack/vue/components/selectcopy.js